import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { AccountCircleRounded } from '@mui/icons-material';

type ActionResponse = { id?: string; name?: string } | string | null;
type ActionArgs = { privateProfileId?: string };

export type AndieGetPrivateProfileByIdProps = ActionRenderAi<ActionResponse, ActionArgs>;

const AndieGetPrivateProfileById = (props: AndieGetPrivateProfileByIdProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse, ActionArgs>
            title={() => t('andie.tool.get-private-profile-by-id.title')}
            icon={<AccountCircleRounded fontSize="small" />}
            privateProfileId={props.args?.privateProfileId}
            loadingMessages={() => [t('andie.tool.get-private-profile-by-id.loading')]}
            completeMessage={() => t('andie.tool.get-private-profile-by-id.complete')}
            {...props}
        />
    );
};

export default AndieGetPrivateProfileById;
